<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <h1 class="title">
              PRIVACY POLICY
            </h1>
          </div>

          <h2>LUDIMOS B.V.</h2>

          <p>
            We attach great importance to your privacy and undertake to protect
            all personal information that we collect and process in relation
            with your use of the www.ludimos.com website, our app and our
            services. This Privacy Policy explains how LUDIMOS and its
            affiliates (hereinafter “we”) process Personal Information.
          </p>
          <b>Who are we</b>
          <p>
            LUDIMOS B.V., established in The Netherlands, in (1186 BP)
            Amstelveen, at In de Wolken 226. Registered at the Chamber of
            Commerce of Amsterdam under number 75739399. Contact email:
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
          </p>

          <p>
            Throughout this Policy, the term “Personal Information” or “Personal
            Data” means information relating to an identified or identifiable
            individual (i.e. a natural person), e.g. name, address, telephone
            number etc. We reserve the right to change this Policy at any time
            without prior notice to you. This Privacy Policy defines the
            conditions in which you authorise LUDIMOS to collect and process
            your personal information.
          </p>
          <b>1. What this privacy policy covers</b>
          <p>
            This Privacy Policy covers the treatment of personal data that
            LUDIMOS may collect when you are visiting the website, our app and
            when you use our services.
          </p>

          <b>2. Which personal data do we collect</b>
          <p>
            We ask you for certain personal data to provide you with the
            products or services you request. For example, when you use our
            website and app, contact our consumer service, request to receive
            communications, create an account, participate in our events or
            contests. This personal data includes your:
          </p>
          <ul>
            <li>
              - contact details (name, email, telephone number and
              shipping/billing address;
            </li>
            <li>
              - login and account information, (including password and unique
              user ID);
            </li>
            <li>- gender,</li>
            <li>- hometown,</li>
            <li>- team name,</li>
            <li>- date of birth,</li>
            <li>- payment or credit card information,</li>
            <li>- images, photos and videos;</li>
            <li>
              - data on physical characteristics, including weight, height, and
              other relevant measurements,
            </li>
            <li>
              - activity data provided by you or generated through our Sites,
            </li>
            <li>- personal preferences,</li>
            <li>- coaching related feedback and counselling</li>
          </ul>

          <p>
            We collect additional personal data from you to enable particular
            features within our Sites and Apps. For example,
          </p>

          <ul>
            <li>- photos, video’s, audio,</li>
            <li>- social media activity and match performance</li>
          </ul>

          <p>
            When interacting with our Site and Apps, certain data is
            automatically collected from your device or web browser. This data
            includes: Device IDs, call state, network access, storage
            information and battery information; and Cookies, IP addresses,
            referrer headers, data identifying your web browser and version, and
            web beacons and tags.
          </p>
          <b>3. Minors</b>
          <p>
            We fully comply with local laws, therefore children under the age of
            16 are not allowed to register on our Sites or Apps without parental
            consent. We will verify the parental consent before providing the
            minor access to the features of our Site and App.
          </p>
          <b> 4. Why we use your personal data</b>

          <ul>
            <li>- To Provide the Features of the website, App, and services</li>
            <li>
              - When you use our website and app, we will use your personal data
              to provide the requested product or service. For example, when you
              contact our consumer service, we will use your information to
              support you and resolve the issue.
            </li>
            <li>
              - If you use our app to track your activity, goals, technique,
              match performance, etc. we will collect this personal data and
              store it so that you can review it in the app. In order to provide
              you the best coaching experience, we may use this activity data to
              calculate further information about your activity.
            </li>
            <li>
              - To Communicate Information about our services or events and for
              other promotional purposes, if you consented to receiving
              promotional/marketing communications. You can opt-out at any time
              after you have provided your consent.
            </li>
            <li>
              - To operate, improve and maintain our services and business
            </li>
            <li>
              - We may also use your personal data about how you use our website
              and app to prevent or detect fraud, abuse, illegal use, or
              violations and to comply with court orders, governmental requests
              or applicable law.
            </li>
            <li>
              - For analysis purposes: to understand customer behaviour or
              preferences.
            </li>
          </ul>

          <b>Use (Processing) of Coaching Information</b>

          <p>
            LUDIMOS collects data about your activity or/ and your physical
            characteristics, together, “COACHING INFO”, to provide our services.
            Because of the personal nature of this data, we strive to provide
            you with clear information about how this information is going to be
            utilised. As some of this data may be considered sensitive, we take
            appropriate measures in protecting and using this data and, where
            required, will obtain your consent for use of your COACHING
            INFORMATION.
          </p>
          <b>
            5. On which legal grounds do we rely for processing your
            information
          </b>
          <ul>
            <li>
              - When you purchase services from our website and app, we need
              your personal data to fulfil our contract with you. More
              specifically, we need your payment and contact details to deliver
              your order.
            </li>
            <li>
              - When you use our app, we rely on your consent for processing and
              for certain purposes to fulfil our contract with you and provide
              you with the service
            </li>
            <li>
              - In a limited number of cases, we rely on our legitimate
              interests as a business, or on the compliance with a legal
              obligation.
            </li>
          </ul>

          <b>6. With whom do we share your information</b>
          <p>We will never sell your personal information.</p>
          <p>
            We may share your information with Third party service providers
            processing personal data on our behalf, for example to process
            credit cards and payments, host, manage and service our data, etc.
            Every time we use third party service providers, we enter into
            agreements that require them to implement appropriate technical and
            organizational measures to protect your personal data.
          </p>
          <p>
            With regard to other third parties, we share your data only to the
            extent necessary to: (i) comply with a government request, a court
            order or applicable law; (ii) prevent illegal uses of our website
            and app and policies; (iii) defend ourselves against third party
            claims; and (iv) assist in fraud prevention or investigation.
          </p>
          <p>
            Please consider that we may also transfer your personal information
            in the event we sell or transfer all or a portion of our business or
            assets (i.e. reorganization, spin-off, dissolution or liquidation).
          </p>
          <b> 7. Data sharing</b>
          <p>
            When you use certain social features on our website and app, you can
            create a public profile that may include information such as your
            screen name, profile picture, team and hometown. You can also share
            content with your friends or the public, including information about
            your activity and sessions. We encourage you to read the privacy
            statements of the social media platform involved very carefully as
            we are not responsible and have no control for how these platforms
            use your personal information.
          </p>
          <b> 8. Where do we process and store your data </b>
          <p>
            We process your personal information in the European Union.
          </p>

          <b>9. How do we protect your personal information?</b>
          <p>
            We use appropriate technical and organizational security measures,
            including encryption and authentication tools, to maintain the
            safety of your personal data. We regularly test our security
            measures to make sure these are up to date and adequate.
          </p>
          <b> 10. For how long we store and process your personal information?</b>
          <p>
            Your personal information will be retained for as long as is
            necessary to carry out the purposes set out in this privacy policy
            (unless a longer retention period is required by applicable law). In
            general, this means that we will keep your personal data for as long
            as you keep your LUDIMOS account. For personal data related to
            service and product purchases, we retain this longer to comply with
            legal obligations (such as tax and sales laws and for warranty
            purposes, i.e. for 7 years).
          </p>
          <b> 11. What are your rights </b>
          <p>
            At all times you have the right to request: (i) access to your
            personal data; (ii) request an electronic copy of your personal data
            (portability); (iii) request the correction of information if it is
            incomplete or inaccurate; or (iv) request deletion or restriction of
            your personal data in certain circumstances provided by applicable
            law. Please consider that these rights are not absolute. In all
            cases where we have obtained your consent for the processing of your
            personal information you maintain the right to withdraw your consent
            at any time.
          </p>
          <p>
            If you like would to request a copy of your personal data or
            exercise any of your other rights, please send dan email to:
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
          </p>
          <b>11- Questions and complaints</b>
          <p>
            Of course, we always welcome your requests, questions and comments
            regarding the way we process your information or this privacy
            policy. If you have questions or concerns or wish to exercise your
            rights related to your personal data, please email us at
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
          </p>
          <p>
            If you contact us with a privacy complaint, we will do our best to
            resolve the matter as timely and effectively as possible and always
            reply to your request within 4 weeks.
          </p>

          <p>
            If you are still not happy with our approach, you have the right to
            lodge a complaint with the Dutch supervisory authority (Nederlandse
            Autoriteit Persoonsgegevens), please see the website:
            <a
              href="https://autoriteitpersoonsgegevens.nl"
            >https://autoriteitpersoonsgegevens.nl</a>
            Or, if you are a Consumer located outside the Netherlands, with your
            local Data Protection Authority.
          </p>

          <b>12. Cookies and Pixel tags</b>
          <p>
            LUDIMOS collects information, which may include personal data, from
            your browser when you use our website. We use a variety of methods,
            such as cookies and pixel tags to collect this information, which
            may include your (i) IP-address; (ii) unique cookie identifier,
            cookie information and information on whether your device has
            software to access certain features; (iii) unique device identifier
            and device type; (iv) domain, browser type and language, (v)
            operating system and system settings; (vi) country and time zone;
            (vii) previously visited websites; (viii) information about your
            interaction with our website such as click behaviour, purchases and
            indicated preferences; and (ix) access times and referring URLs.
          </p>

          <b>We use the following cookies:</b>
          <ul>
            <li>
              - Functional: These cookies are required for basic site
              functionality and are therefore always enabled.
            </li>
            <li>
              - Performance: These cookies allow us to improve our website’ s
              functionality by tracking usage. In some cases, these cookies
              improve the speed with which we can process your request and allow
              us to remember site preferences you have selected. Refusing these
              cookies may result unjust recommendations and slow site
              performance.
            </li>
            <li>
              - Social media: Social media cookies offer the possibility to
              connect you to your social networks and share content from our
              Sites through social media.
            </li>
          </ul>

          <p>
            Please be informed that you can always change your preference by
            visiting the "Cookie Settings" at the bottom of each page of our
            website.
          </p>
          <p>
            Our website and apps may provide links to other (third party)
            websites and apps for your convenience or information. Linked sites
            and apps have their own privacy notices or policies, which we
            strongly encourage you to review. To the extent any linked websites
            or apps are not owned or controlled by us, we are not responsible
            for their content, any use of the websites or apps, or the privacy
            practices of the websites or apps.
          </p>
          <p>
            Laws and practices always evolve and change, as a result we might
            have to modify our privacy policy, in such a case we will post the
            changes on our website and app. We strongly encourage you to visit
            this page regularly to keep track of possible changes.
          </p>
          <p>This privacy policy was last modified on 8 May 2020.</p>

          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivayPolicy",
  metaInfo() {
    return {
      title: this.textEllipsis(`Privay Policy`, 25),
    };
  },
};
</script>

